import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { models } from "powerbi-client";
import { PowerBIEmbed } from 'powerbi-client-react';
import utils from '../utils';

import vizUtils from '../VizUtils';


import '../styles/components/_pbi-report.scss';

function PBIEmbedClassDriven(props) {

    let [ embedData, setEmbedData ] = useState({embedUrl: undefined, token: undefined});



    const { getAccessTokenSilently, user } = useAuth0();

    //construct filter if exists on config
    // Our powerBI service expects the each powerBI served to have roles for each security level 1-Q. If getting an error makesure PBI that is being called has the role table in it.

    const getEmbedData = async () => {
        let tokenForUse = await utils.getAccessToken(getAccessTokenSilently, user);

        let embedInfo = await vizUtils.getEmbedData(props.reportID, props.datasetID, props.tenID, tokenForUse, props.reportType);

        if(embedInfo) {
            setEmbedData(embedInfo);
        } 

    }

    useEffect( ()=> {
        getEmbedData();

        return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.reportID])

    return (
            <div>
                <PowerBIEmbed 
                    embedConfig = {{
                        type: 'report',   // Supported types: report, dashboard, tile, visual, qna, paginated report and create
                        id: props.reportID,
                        embedUrl: embedData.embedUrl,
                        accessToken: embedData.token,
                        
                        tokenType: models.TokenType.Embed, // Use models.TokenType.Aad for SaaS embed - was models.TokenType.Embed
                        filters: props.filters? props.filters : [],
                        settings: {
                            zoomLevel: props.zoomLevel? props.zoomLevel : 1,
                            // leaving to show potential options we may want to change later
                            // layoutType: props.layoutType ? props.layoutType : models.LayoutType.Custom,
                            // customLayout: {
                            //     pageSize: {
                            //         type: props.pageSizeType ? props.pageSizeType : models.PageSizeType.Custom,
                            //         width: props.initWidth ? props.initWidth : '100%',
                            //         height: props.initHeight ? props.initHeight : 800
                            //     },
                            // },
                            // displayOption: props.displayOption ? props.displayOption : models.DisplayOption.FitToWidth,
                            panes: {
                                filters: {
                                    expanded: false,
                                    visible: false
                                },
                                pageNavigation: {
                                    visible: false
                                }
                            }
                        }
                    }}
                    cssClassName={props.className}
                />
            </div>        
    )
}

export default PBIEmbedClassDriven